import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableOptions } from '../../models';
import { CardTableHeader } from '../../models/card-table-header.model';
import { NavigationService } from '@huge-monorepo/portal/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-table-header',
  templateUrl: './card-table-header.component.html',
  styleUrls: ['./card-table-header.component.scss'],
})
export class CardTableHeaderComponent implements OnInit, OnDestroy {
  @Input() prefixTemplate: TemplateRef<any>;
  @ViewChild('prefix') prefix: TemplateRef<any>;

  @Input() cardTemplate: TemplateRef<any>;
  @ViewChild('cardContent') cardContent: TemplateRef<any>;

  @Input() rowTemplate: TemplateRef<any>;
  @ViewChild('rowContent') rowContent: TemplateRef<any>;

  @Input() affixTemplate: TemplateRef<any>;
  @ViewChild('affix') affix: TemplateRef<any>;

  @Input() headers: CardTableHeader[];
  @Input() row: any;
  @Input() options: CardTableOptions;
  @Input() breakpoint: ScreenSize;
  @Input() sortedIndex: number;
  @Input() originalStyling: boolean = true;

  @Output()
  selectedEvent = new EventEmitter<any>();

  @Output()
  sortedEvent = new EventEmitter<[CardTableHeader, number]>();

  isSelected = false;
  isSideNavCollapsed: boolean = false;
  sub: Subscription;

  constructor(public layoutService: LayoutService, private navigationService: NavigationService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['row']) {
    }
  }

  ngOnInit(): void {
    if (this.row && this.row.$implicit) {
      this.isSelected = this.row.$implicit[this.options.selectedProperty];
    }
    this.isSideNavCollapsed = this.navigationService.GetIsCollapsed();
    this.sub = this.navigationService.isCollapsed.subscribe((isCollapsed) => {
      this.isSideNavCollapsed = isCollapsed;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  selected(): void {
    if (this.options.isSelectable) {
      this.isSelected = !this.isSelected;
    }
    console.log("Row: ",this.row);
    this.selectedEvent.emit(this.row);
  }

  onHover(header: CardTableHeader, entered: boolean, index: number) {
    if (entered) {
      this.headers[index].ShowSorting = true;
    } else {
      if (this.sortedIndex != index) {
        this.headers[index].ShowSorting = false;
      }
    }
  }

  configureTooltip(header, property) {
    const status = property.value.status ? 'Online' : 'Offline';
    return `${header.TooltipText}: ${status}
    Updated: ${property.value.lastSeen ? property.value.lastSeen : 'N/A'}`;
  }

  sort(header: CardTableHeader, index: number) {
    if (this.sortedIndex != index) {
      this.sortedIndex = index;
    } else {
      this.headers[index].SortAscending = !this.headers[index].SortAscending;
    }
    if (this.headers[index].SortAscending == null) {
      this.headers[index].SortAscending = false;
    }
    this.headers.map((header) => {
      header.ShowSorting = false;
      return header;
    });
    this.headers[index].ShowSorting = true;
    this.sortedEvent.emit([header, index]);
  }
}
